export interface OnCancelConfirmationRequest {
    /**
     * A hook called by ToolbarService when loading a new tool
     * in order to check if the user wants to discard unsaved changes
     */
    onCancelConfirmationRequest(): Promise<boolean>;
}

/**
 * Checks if a component implements the OnCancelConfirmationRequest interface
 * @param component Component to check
 */
export function isOnCancelConfirmationRequest(component: object): component is OnCancelConfirmationRequest {
    return typeof (component as OnCancelConfirmationRequest)?.onCancelConfirmationRequest === 'function';
}
